<template>
  <div id="meet-body" ref="personFileElement">
    <BlockFrame :header="{title:appletData.name,icon:appletData.icon,more:true,code:'hygl_dhz'}">
      <el-table
        v-if="pageTotal>0"
        :data="listData"
        :show-header="true"
        :border="true"
        @cell-click="cellClick"
      >
        <el-table-column type="index" :label="$tx('hygl.portlet.index','序号')" width="45" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.flSubject? scope.$index+ 1:'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="flSubject"
          :label="$tx('hygl.portlet.conferenceTitle','会议主题：')"
          align="left"
        />
        <el-table-column
          v-if="contentWidth>320"
          prop="meetPlace"
          :label="$tx('hygl.portlet.meetingRoom','会议室')"
          width="110"
          align="center"
        />
        <el-table-column
          v-if="contentWidth>460"
          prop="startTime"
          :label="$tx('hygl.portlet.startTime','开始时间')"
          width="150"
          align="center"
        />
        <el-table-column
          v-if="contentWidth>600"
          :label="$tx('hygl.portlet.endTime','结束时间')"
          prop="endTime"
          width="150"
          align="center"
        />
      </el-table>
      <div v-else style="text-align:center;padding-top: 30px;">
        <img src="images/w-imgs/nomessage.png" style="max-width:180px"><br>
        <span v-text-lbl="'common.noData'" style="font-size: var(--portalFontSize15);color:#dbdbdb"> 暂无数据 </span>
      </div>
    </BlockFrame>
    <my-join ref="myJoinMeeting" />
  </div>
</template>

<script>
export default {
    props: {
        appletData: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            moduleInfo: { 'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/vwMyMeetingJoin/form.html', 'winWidth': 1000, 'delUrl': 'hygl/vwMyMeeting/delete', 'addNewUrl': 'hygl/vwMyMeeting/addNew', 'insertUrl': 'hygl/vwMyMeeting/insert', 'moduleCode': 'vwMyMeeting', 'listAdvSearchExpandPanel': 0, 'winHeight': 600, 'updateUrl': 'hygl/vwMyMeeting/update', 'listDataUrl': 'hygl/vwMyMeeting/listdata', 'getByIdUrl': 'hygl/hyap/getById', 'listAdvSearchAllFields': 0 },
            loginUser: this.$store.getters.loginUser,
            contentWidth: '', // 浏览器窗口宽度
            pageTotal: 0,
            checkType: '',
            listData: [],
            searchType: 0, // 首页默认文件夹
            params: {},
            listDataUrl: '',
            dialogTableVisible: false
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.getListData()
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')
        this.$options.components['myJoin'] = this.$loadComponent('@/wapp/hygl/components/wdhy/HyglWdhyMyJoin')
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onresize, false)
        this.$bus.off('refreshTableData', this.refreshTableData)
        this.$bus.$off('clicklog')
    },
    mounted() {
        window.addEventListener('resize', this.onresize, false)
        this.$bus.on('refreshTableData', this.refreshTableData)
    },
    methods: {
        onresize() {
            this.contentWidth = this.$refs.personFileElement.offsetWidth
        },
        refreshTableData() {
            this.getListData(this.checkType)
        },
        getListData(index) {
            this.checkType = index
            // 获取dom元素宽度
            this.$nextTick(function() {
                this.contentWidth = this.$refs.personFileElement.offsetWidth
            })
            // this.listDataUrl = '/znbg/task/listdata?urlsearch=myType:1;status:0;isExecutor:0'
            var param = {
                pageSize: 5,
                pageNum: 1,
                listpageViewUrl: 'hygl.vwMyMeetingMyJoin.list.vue'
            }
            this.$http({
                method: 'post',
                url: '/hygl/vwMyMeeting/listdata',
                params: param
            }).then(res => {
                if (res.code === 'success') {
                    this.listData = res.body.pageInfo.list
                    this.pageTotal = res.body.pageInfo.total
                    const length = this.listData.length
                    if (length < 5 && length > 0) {
                        for (let i = 0; i < 5 - length; i++) {
                            this.listData.push({})
                        }
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        cellClick(row) {
            this.$bus.$emit('clicklog', row)
        },
        // 打开表单
        openBusiForm(row, canEdit) {
            //	this.moduleInfo.formTemplate='#/dcontent/vuebusiform/W/znbg.task.mainForm.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent('#/dcontent/vuebusiform/W/znbg.task.mainForm.vue?sysCode=' + this.$route.meta.sysCode)
            this.formTitle = '会议详情'
            this.moduleInfo.showFile = true
            this.moduleInfo.personName = this.$store.state.user.loginUser.personName
            this.isUpdate = 1
            if (this.$store.state.user.loginUser.personName === row.createName || row.taskExecutorName.indexOf(this.$store.state.user.loginUser.personName) > -1) {
                this.busiformBtns = []
            } else {
                this.busiformBtns = [
                    {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermission: '',
                        btnType: ''
                    }
                ]
            }
            var that = this
            this.$nextTick(function() {
                that.$bus.emit('openBusiform', that.moduleInfo, row, canEdit)
                // that.$forceUpdate()
            })
        }
    }
}
</script>

<style scoped lang="scss">
#meet-body{
    height: 100% !important;
}
//    /deep/ .el-table .el-table__header-wrapper .el-table__header thead th{
//         // font-size: var(--portalFontSize14);
//         background-color: #fff;
//         //border: none;
//     }
//     /deep/ .el-table__body-wrapper{
//         cursor: pointer;
//     }
//     // /deep/ .el-table td, .el-table th.is-leaf{
//     //     border: none;
//     // }
//     /deep/.el-table::before {
//         height: 0px;
//         width: 0;
//     }
//    /deep/ .el-table .cell{
//         white-space: nowrap;
//         text-overflow: ellipsis;
//         overflow: hidden;
//     }
// }
//     /deep/ .el-table__body{
//         height:225px;
//     }
/deep/ .has-gutter tr th{
        background-color: #fff !important;
     }

</style>
